import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-89d5e8d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "sw-announcement-line--items" }
const _hoisted_3 = { class: "sw-announcement-line--items-item-date" }
const _hoisted_4 = { class: "sw-announcement-line--items-item-title" }
const _hoisted_5 = { class: "sw-announcement-line--buttons" }

import {
  computed,
  ref,
  onMounted,
} from 'vue';
import SwButton from '@/components/molecules/Buttons/SwButton.vue';
import { Notices } from '@/api/spotwrite';
import NoticeService from '@/api/NoticeService';
import useNoticesFunc from '@/components/utils/NoticesUtil';


export default /*#__PURE__*/_defineComponent({
  __name: 'SwAnnouncementLine',
  setup(__props) {

const noticesUtil = useNoticesFunc();

/**
 * class 属性
 */
const classes = computed(() => ({
  'sw-announcement-line': true,
}));

/**
 * 最新のお知らせ
 */
const notices = ref<Notices[]>([]);

const hasNotices = computed(() => notices.value && notices.value.length > 0);

const fetchData = async () => {
  const res = await NoticeService.latest(1);
  if (res) {
    notices.value = res;
  }
};

onMounted(async () => {
  await fetchData();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_unref(hasNotices))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(_unref(classes))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notices.value, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.title,
                  class: "sw-announcement-line--items-item"
                }, [
                  _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(noticesUtil).getPublishDate(item)), 1),
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_router_link, {
                      to: { name: 'informationDetail', params: { informationId: item?.id } }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.title), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ])
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(SwButton, {
                label: "お知らせ一覧へ",
                color: "primary",
                size: "small",
                to: "/informations"
              })
            ])
          ])
        ])
      ], 2))
    : _createCommentVNode("", true)
}
}

})